import React,{useState,useEffect} from "react";
import { Trans, useTranslation} from 'react-i18next'
import NervousPlusLogo from './../../../../images/nervouspluslogo.png'
import { useJwt, decodeToken } from "react-jwt";
import Cookies from 'universal-cookie';
import ReactModal from 'react-modal';
import CrossIcon from './../../../../images/crossicon.png'
import  {useNavigate} from "react-router-dom";

function AccountSettings({hidedashboard,toogleOption,toogleTaskbar}){
   const {t, i18n } = useTranslation();
   const cookies = new Cookies(null ,{ path: '/' });
   const [name,setName] = useState() 
   const [email,setEmail] = useState()
   const [changeEmailPopup,setChangeEmailPopup] = useState(false)
   const [deleteAccPopup,setDeleteAccPopup] = useState(false)
   const [deleteSuccessfulPopUp,setDeleteSuccessfulPopup] = useState(false)
   const [currentPassword,setCurrentPassword] = useState("")
   const [newEmail,setNewEmail] = useState("")
   const [emailInvalidError,setEmailInvalidError] = useState(false)
   const [deleteAccInput,setDeleteAccInput] = useState("")
   const [confirmdeleteAcc,setConfirmDeleteAcc] = useState(false)
   const navigate = useNavigate();


   const confirmDeleteAcc = (val) =>{
      if(val==="delete my account permanently"){
          setConfirmDeleteAcc(true)
      }
  }

   const handleSubmit = (val) =>{
      let emailRegex = /[a-z0-9]+@[a-z0-9]+\.[a-z]{2,3}/;
  
      if(val.length!==0){
        if (!emailRegex.test(val)) {
        // invalid email
         setEmailInvalidError(true)
        } else {
         setEmailInvalidError(false)
        }   
      }
  
    
  }


   useEffect(()=>{
      setEmail(decodeToken(cookies.get('token')).email)
      if(decodeToken(cookies.get('token')).info!==undefined){
         setName(decodeToken(cookies.get('token')).info.firstName.concat(" ").concat(decodeToken(cookies.get('token')).info.lastName))
      }
      toogleOption(2)
   },[])

      return (
         <div style={{paddingBottom:'2.5em',borderRadius:'8px',marginLeft:'2.5em',marginTop:'1.5em',width:'93.28%',backgroundImage:' linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>

                  <div className="MembershipTxt">{t('Membership')}</div>
         
                                 <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',marginLeft:'5em',border:'1px rgba(255,255,255,25%) solid',width:'25em',borderRadius:'8px',marginTop:'1.5em',backgroundColor:'rgba(255,255,255,8%)',cursor:'pointer'}}>
                                    <div style={{display:'flex',flexDirection:'row',height:'100%',alignItems:'flex-start',paddingLeft:'1.5em',paddingTop:'0.75em',paddingBottom:'0.75em'}}>
                                       <img style={{width:'1.5em',height:'1.5em',marginRight:'0.5em'}} src={NervousPlusLogo} alt="Plan Logo"/>
                                          <div style={{display:'flex',flexDirection:'column'}}>
                                             <div style={{fontFamily:'ClashGrotesk-Variable,sans-serif',
                                                         fontSize:'1.3em',
                                                            fontWeight:500,
                                                         lineHeight:'100%',
                                                      letterSpacing:'3%',
                                                color:"#FFFFFF"}}
                                                         >{decodeToken(cookies.get('token')).plan}</div>

                                             <span style={{fontFamily:'ClashGrotesk-Variable,sans-serif',
                                                         fontSize:'1em',
                                                            fontWeight:'regular',
                                                         lineHeight:'150%',
                                                      letterSpacing:'3%',
                                                      color:"#FFFFFF"}}>
                                                         {/* 12 {t('Months')}
                                                         / 
                                                      
                                                      {cookies.get('lang') === 'en' &&
                                                      <span>$19.99</span>}

                                                      {cookies.get('lang') === 'jp' &&
                                                      <span>３０００円</span>} */}
                                                      {
                                                         decodeToken(cookies.get('token')).plan==="nervous" &&
                                                         <span>Free</span>
                                                      }
                                                      </span>
                                          </div>
                                    </div>
         
                                    <div className="ChangePlanTxt" onClick={()=>{navigate("/Dashboard/settings/changeplan")}}>
                                    {t('Changeplan')}
                                    </div>
                                 </div>
         
                                 <div className="MembershipTxt" style={{marginBottom:'1.5em'}}>{t('AccountInfo')}</div>
         
                                 <div className="ProfileSettingHeader" style={{marginLeft:'5em'}}>Account Holder Name</div>
                                 <input
                                    value={name}
                                    onChange={e => setName(e.target.value)} 
                                    className='FormInput'
                                    type='text'
                                    style={{marginLeft:'4.8em'}}
                                    />
                                 <div className="ProfileSettingHeader" style={{marginLeft:'5em'}}>{t('Email')}</div>
         
                                 <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.5em',marginBottom:'1.5em'}}> 
                                             <div className="ArtistNameBox" style={{marginLeft:'4.8em',paddingRight:'10em'}}>
                                                {email}
                                             </div>
         
                                             <div className="ChangeTxt" style={{cursor:'pointer'}} onClick={()=>setChangeEmailPopup(true)}>
                                             {t('Change')}
                                             </div>
                                 </div>
         
                                 <div className="UpdateBtn">
                                 Submit
                                 <div className="PostLoginBtnOverlay" style={{left:'0em'}}/>
                                 </div>

                                 <div className="DeleteAccBtn" onClick={()=>setDeleteAccPopup(true)}>
                                    Delete Account
                                 </div>
                  

                  <ReactModal
                                 overlayClassName="Overlay"
                                 isOpen={changeEmailPopup}
                                 contentLabel="Example Modal"
                                 style={{
                                    content:{
                                    width:'38em',
                                    height:'25.43em',
                                    margin:'auto',
                                    backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
                                    display:'flex',
                                    flexDirection:'column',
                                    alignItems:'center',
                                    borderRadius:'8px',
                                    border:'0.5px solid rgba(255,255,255,25%)'
                                    }
                                 }}
                                 >
                                    
                                    <div className="popupheaderinfo">Change Email</div>
                                       
                                    <img src={CrossIcon} style={{position:'absolute',top:'1.5em',right:'1.5em',cursor:'pointer'}} onClick={()=>setChangeEmailPopup(false)}/>
                                    
                                       
                                    <div className="MfaInputHeader" style={{marginTop:'2em'}}>
                                          Current password
                                    </div>

                                    
                                    <input
                                    value={currentPassword}
                                    onChange={e => setCurrentPassword(e.target.value)} 
                                    className='ChangeEmailInput'
                                    type='password'
                                    placeholder="Enter current password"
                                    />
                                          

                                    <div className="MfaInputHeader">
                                          New email address
                                    </div>

                                    
                                          <input
                                          value={newEmail}
                                          onChange={e => {setNewEmail(e.target.value);handleSubmit(e.target.value)}} 
                                          className={emailInvalidError?'ChangeEmailInputError':'ChangeEmailInput'}
                                          type='text'
                                          placeholder="Enter email address"
                                          />
                                    
                                    
            
                                 {
                                    emailInvalidError && 
                                    <div className='ErrorTxt' style={{marginTop:'0.5em',alignSelf:'flex-start',marginLeft:'2.5em'}}>Please enter a valid email</div>
                                 }
                                 
                                 

                                    <div style={{display:'flex',flexDirection:'row',marginTop:'5em',position:'absolute',bottom:'2em',right:'1em'}}>
                                             <div className="GoBackBtn" style={{marginRight:'1em',cursor:'pointer',display:'flex',alignItems:'center',width:'10em',justifyContent:'center'}} onClick={()=>{setChangeEmailPopup(false)}}>
                                                Cancel
                                             </div>
                                          
                                             {
                                                (currentPassword.length===0 || newEmail.length===0) && 
                                                <div className="IUnderstandBtn" style={{height:'3em',cursor:'pointer',width:'10em',backgroundImage:'#E91353',color:'#8D9297'}} onClick={()=>{setChangeEmailPopup(false);}}>
                                                      Save
                                                </div>
                                             }

                                             {
                                                currentPassword.length!==0 && newEmail.length!==0 &&
                                                <div className="IUnderstandBtn" style={{height:'3em',cursor:'pointer',width:'10em',backgroundColor:'#821D41',backgroundImage:'#E91353'}} onClick={()=>{setChangeEmailPopup(false);}}>
                                                Save
                                             </div>
                                             }
                                             
                                    </div>
                                          
                  </ReactModal>

                  <ReactModal
                                    overlayClassName="Overlay"
                                 isOpen={deleteAccPopup}
                                 contentLabel="Example Modal"
                                 style={{
                                    content:{
                                    width:'35em',
                                    height:'21.31em',
                                    margin:'auto',
                                    backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
                                    display:'flex',
                                    flexDirection:'column',
                                    alignItems:'center',
                                    borderRadius:'8px',
                                    border:'0.5px solid rgba(255,255,255,25%)'
                                    }
                                 }}
                                 >
                                    
                                          <div className="popupheaderinfo" style={{fontSize:'1.5em'}}>Confirm Account Deletion</div>
                                          <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'1.5em',top:'1.5em',cursor:'pointer'}} onClick={()=>setDeleteAccPopup(false)}/>
                                       

                                    

                                          <span className="SettingPopupH3" style={{width:'85%',marginTop:'2em',marginLeft:'-1.2em'}}>Deleting your account will lose membership perks, products, assets, and releases. This action cannot be undone. </span>
                                          <div className="MfaInputHeader">
                                          To confirm, type “delete my account permanently” below:
                                          </div>

                                    
                                          <input
                                          value={deleteAccInput}
                                          onChange={e => {setDeleteAccInput(e.target.value);confirmDeleteAcc(e.target.value)}} 
                                          className='DeleteAccInput'
                                          type='text'
                                          placeholder="delete my account permanently"
                                          />
                                       

                                          <div style={{display:'flex',flexDirection:'row',marginTop:'2em'}}>
                                             <div className="GoBackBtn" style={{paddingTop:'0.55em',paddingBottom:'0.5em',marginRight:'1em',cursor:'pointer'}} onClick={()=>{setDeleteAccPopup(false)}}>
                                                Cancel
                                             </div>

                                             {
                                                confirmdeleteAcc &&
                                                <div className="IUnderstandBtn" style={{height:'3em',cursor:'pointer'}} onClick={()=>{setDeleteAccPopup(false);setDeleteSuccessfulPopup(true)}}>
                                                      Delete Account
                                                </div>
                                             }

                                             {
                                                !confirmdeleteAcc &&
                                                <div className="IUnderstandBtn" style={{backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}} >
                                                      Delete Account
                                                </div>
                                             }
                                             
                                          </div>
                  </ReactModal>

                  <ReactModal
                                 overlayClassName="Overlay"
                                 isOpen={deleteSuccessfulPopUp}
                                 contentLabel="Example Modal"
                                 style={{
                                    content:{
                                    width:'35em',
                                    height:'21.31em',
                                    margin:'auto',
                                    backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
                                    display:'flex',
                                    flexDirection:'column',
                                    alignItems:'center',
                                    borderRadius:'8px',
                                    border:'0.5px solid rgba(255,255,255,25%)'
                                    }
                                 }}
                                 >
                                    
                                          <div className="popupheaderinfo" style={{fontSize:'1.5em'}}>Confirm Account Deletion</div>
                                          <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'1.5em',top:'1.5em',cursor:'pointer'}} onClick={()=>setDeleteSuccessfulPopup(false)}/>
                                       

                                    

                                          <span className="SettingPopupH3" style={{width:'90%',marginTop:'2em',marginLeft:'0em'}}>If you have released music through our service and wish to delete your account, we must first settle any outstanding statements and payments for the time your releases were active. Due to stores reporting with a delay, these statements may arrive even after your releases are removed, which can also delay the deletion of your account. For assistance with distributed releases and account deletion, please reach out to our support team at: <span style={{color:'#C7A5FF'}}>support@n3rve.com</span></span>
                                       
                                       
                                          <div className="IUnderstandBtn" style={{cursor:'pointer',width:'90%'}} onClick={()=>{setDeleteSuccessfulPopup(false)}}>Got it</div>
                                       
                  </ReactModal>
         </div>
      )
}

export default AccountSettings;